import { type Method } from 'axios';

// TBD: (By Adir) change this file to query.ts and change var names to be more query oriented. stream can be interpreted as video / camera stream.
type StreamBody = Record<string, unknown>;

type StreamOptions = {
    url: string;
    method: Method;
    body: StreamBody;
    signal?: AbortSignal;
};

type OnChunkFunction = (chunk: string, index: number) => void;

type OnDoneFunction = () => void;

type OnEmptyResponseFunction = () => void;

type OnStartFunction = () => void;

type ProcessStreamParams = {
    reader: ReadableStreamDefaultReader<Uint8Array>;
    decoder: TextDecoder;
    buffer: string;
    chunkIndex: number;
    onChunk: OnChunkFunction;
    onDone: OnDoneFunction;
    onEmptyResponse: OnEmptyResponseFunction;
    onStart: OnStartFunction;
};

type StreamCallbacks = Pick<
    ProcessStreamParams,
    'onChunk' | 'onDone' | 'onEmptyResponse' | 'onStart'
>;

export enum QueryStreamMessageType {
    Event = 'event',
    Error = 'error',
    AnalyzedQueries = 'analyzed_queries',
    Vehicles = 'vehicles',
    Persons = 'persons',
    Meta = 'meta',
}

export type { ProcessStreamParams, StreamOptions, StreamCallbacks };
